import { IconToggleLeftFilled, IconToggleRightFilled } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { getApi } from "../../api/call.api";
import { urlApi } from '../../api/url.api';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../components/DataTable/TableComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { accessKeys } from '../../statics/accessKeys';
import { accessCheck } from '../../utils/accessCheck';
import { dateTimeConverter } from '../../utils/dateTimeConverter';
import AccessModal from './Components/AccessModal';
import AddAdmin from './Components/AddAdmin';

const Admins = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    async function getAllAdmin() {
        loadingShow();
        let resp = await getApi(`${urlApi.allAdmin}?page=${activePage}&limit=${perPage}`);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getAllAdmin();
    }, [activePage, perPage])

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateAdminStatus}${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getAllAdmin();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.username, cell: (row) => (
                <div className='flex items-center gap-2 py-2'>
                    <img src={row?.profilePic} alt={`${row?.username}-profile-pic`} className='h-8 aspect-square rounded-full object-cover' />
                    <p className='fw-bold'>{row?.username}</p>
                </div>
            ),
        },
        { name: "Mobile", center: "true", selector: (row) => row?.phone, cell: (row) => (<span> {row?.phone ?? "--"}</span>), },
        { name: "Created", center: "true", selector: (row) => row?.createdAt, cell: (row) => dateTimeConverter(row?.createdAt), },
        { name: "Last Login", center: "true", selector: (row) => row?.lastLogin, cell: (row) => dateTimeConverter(row?.lastLogin), },
        {
            name: "Status", center: "true", selector: (row) => row?.status, cell: (row) =>
                // accessCheck(accessKeys.updateAdminStatus) ?
                <ConfirmationModal
                    buttonComponent={row?.status == 1 ? <IconToggleRightFilled className='text-green-600 cursor-pointer transition-all' /> : <IconToggleLeftFilled className='text-red-700 cursor-pointer transition-all' />}
                    confirmationText={`Are You Sure Want To ${row?.status == 1 ? 'Deactivate' : "Activate"} ${row?.username} ?`}
                    onConfirm={() => updateStatus(row?._id, row?.status == 1 ? 2 : 1)}
                />
            //  :
            // row?.status == 1 ? <IconToggleRightFilled className='text-green-600 transition-all' /> : <IconToggleLeftFilled className='text-red-700 transition-all' />
        },
        // { name: "Update", center: "true", selector: (row) => row?.action, omit: !accessCheck(accessKeys.updateAdmin), cell: (row) => accessCheck(accessKeys.updateAdmin) && <UpdateAdmin adminData={row} callback={() => getAllAdmin()} /> },
        { name: "Action", center: "true", selector: (row) => row?.action, omit: !accessCheck(accessKeys.getAdminAccess), cell: (row) => accessCheck(accessKeys.getAdminAccess) && <AccessModal adminData={row} /> },
    ];

    return (
        <Layout>
            <div className='flex items-center mb-3 justify-between mt-2'>
                <h1 className='text-xl font-bold text-gray-600'>Admins</h1>
                {/* {accessCheck(accessKeys.addAdmin) && */}
                <AddAdmin callback={() => getAllAdmin()} />
                {/* } */}
            </div>
            {<TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />}
        </Layout>
    )
}

export default Admins